import { getModule, Module, Mutation, VuexModule } from 'vuex-module-decorators';
import { store } from '@/store';
import moment from 'moment';
import { DateUtils } from '@/utils/date.utils';

export interface IGlobalState {
  activeMenu: string; // 現在参照中のメニュー
  currentDate: Date; // 現在時刻(テスト用に時間変更可能にするために状態として保有)
  selectedSchoolYear: number; // 選択年度
}
@Module({ dynamic: true, store, name: 'globalModule', namespaced: true })
class GlobalModule extends VuexModule implements IGlobalState {
  activeMenu: string = '';
  currentDate: Date = new Date();
  selectedSchoolYear: number = 0;

  get now(): Date {
    return this.currentDate ? this.currentDate : new Date();
  }

  get isCurrentNewYear(): boolean {
    return [1, 2, 3].includes(moment(this.currentDate).month() + 1);
  }

  // 現在の年度末の年を取得
  get endSchoolYear(): number {
    if (moment(this.now).month() < 3) {
      return this.now.getFullYear();
    }
    return this.now.getFullYear() + 1;
  }

  get isOldSchoolYear(): boolean {
    return this.selectedSchoolYear < DateUtils.currentSchoolYear(this.currentDate);
  }

  get currentYear(): number {
    return this.currentDate.getFullYear();
  }

  // 現在の年度を取得
  get currentSchoolYear(): number {
    return [1, 2, 3].includes(moment(this.currentDate).month() + 1) ? moment(this.currentDate).year() - 1 : moment(this.currentDate).year();
  }

  get isNewSchoolYear(): boolean {
    return globalModule.selectedSchoolYear > globalModule.currentSchoolYear;
  }

  @Mutation
  setCurrentDate(value: Date) {
    this.currentDate = value;
  }

  @Mutation
  setActiveMenu(value: string) {
    this.activeMenu = value;
  }
  @Mutation
  setSelectedSchoolYear(value: number) {
    this.selectedSchoolYear = value;
  }
}

export const globalModule = getModule(GlobalModule);
